import React from 'react';
import api from 'api';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner, ConfirmModal } from 'hyperdb-utils';
import { Modal } from 'hyperdb-utils';
import { MetadataTab, TextsTab, GalleryTab } from '../components';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.toggleModalPicture = this.toggleModalPicture.bind(this);
    this.handleChangePicture = this.handleChangePicture.bind(this);
    this.handleUploadPicture = this.handleUploadPicture.bind(this);
    this.toggleModalDeletePicture = this.toggleModalDeletePicture.bind(this);
    this.handleDeletePicture = this.handleDeletePicture.bind(this);
    this.toggleModalGallery = this.toggleModalGallery.bind(this);
    this.handleChoosePictures = this.handleChoosePictures.bind(this);
    this.handleAddGalleryPictures = this.handleAddGalleryPictures.bind(this);
    this.handleMovePicture = this.handleMovePicture.bind(this);
    this.toggleModalRemoveGalleryPicture = this.toggleModalRemoveGalleryPicture.bind(this);
    this.handleRemoveGalleryPicture = this.handleRemoveGalleryPicture.bind(this);
  }
  componentDidMount() {
    const propertyId = this.props.propertyId;
    if (!this.props.id) {
      const objectData = {
        id: 0,
        property: { $type: 'reference', external: true, value: ['properties', propertyId] },
        website: {},
        email: {},
      };
      this.props.api.propertyContent.submitCreateForm(objectData)
        .then(() => {
          if (this.props.savedObject) {
            const id = this.props.savedObject.id;
            this.props.api.propertyContent.initEditForm(id);
            this.props.api.property.updateEditedObject({
              attributeName: 'content',
              value: { $type: 'reference', external: true, value: ['property_contents', id] },
            });
          }
        });
    } else {
      this.props.api.propertyContent.initEditForm(this.props.id);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadSuccess) {
      this.props.api.propertyContent.setData({ uploadSuccess: false });
      if (nextProps.editedPicture) {
        const websiteContent = { ...nextProps.objectData.website };
        const fieldname = `${nextProps.typePicture}_image`;
        websiteContent[fieldname] = nextProps.savedPicture;
        this.props.api.propertyContent.updateEditedObject({ attributeName: 'website', value: websiteContent });
      }
      this.toggleModalPicture(false);
    }
    if (nextProps.deletePictureSuccess) {
      this.props.api.propertyContent.setData({ deletePictureSuccess: false });
      const websiteContent = { ...nextProps.objectData.website };
      const fieldname = `${nextProps.typePicture}_image`;
      websiteContent[fieldname] = null;
      this.props.api.propertyContent.updateEditedObject({ attributeName: 'website', value: websiteContent });
      this.toggleModalDeletePicture(false);
    }
  }
  render() {
    if (!this.props.objectData) return <Spinner show={ this.props.show } />;

    const websiteContent = this.props.objectData.website || {};
    const emailContent = this.props.objectData.email || {};
    const gallery = this.geGalleryPictures(websiteContent.gallery);
    const propertyId = this.props.propertyId;
    const propertyPictures = this.props.api.getState('property').objectData.pictures || [];
    const { currentUser } = this.props.api.getState('auth');
    return (
      <div style={ {display: this.props.show ? 'block' : 'none'} }>
        <Tabs defaultActiveKey={1} id="content-form">
          <Tab eventKey={1} title="Metadata">
            <MetadataTab
              { ...this.props }
              websiteContent={ websiteContent }
              onChange={ this.handleChange.bind(this, 'website') }
              availableLocales={ this.props.availableLanguages }
              toggleModalPicture={ this.toggleModalPicture }
              onChangePicture={ this.handleChangePicture }
              onUploadPicture={ this.handleUploadPicture }
              toggleModalDeletePicture={ this.toggleModalDeletePicture }
              onDeletePicture={ this.handleDeletePicture }
            />
          </Tab>
          <Tab eventKey={2} title="Texts">
            <TextsTab
              { ...this.props }
              websiteContent={ websiteContent }
              onChange={ this.handleChange.bind(this, 'website') }
              availableLocales={ this.props.availableLanguages }
            />
          </Tab>
          {/*
            <Tab eventKey={3} title="Gallery">
              <GalleryTab
                { ...this.props }
                currentUser={ currentUser }
                gallery={ gallery }
                propertyId={ propertyId }
                propertyPictures={ propertyPictures }
                toggleModalGallery={ this.toggleModalGallery }
                onChoosePictures={ this.handleChoosePictures }
                onAddGalleryPictures={ this.handleAddGalleryPictures }
                onMovePicture={ this.handleMovePicture }
                toggleModalRemoveGalleryPicture={ this.toggleModalRemoveGalleryPicture }
                onRemoveGalleryPicture={ this.handleRemoveGalleryPicture }
              />
            </Tab>
          */}
        </Tabs>
      </div>
    );
  }

  handleChange(attributeName, value) {
    this.props.api.propertyContent.updateEditedObject({ attributeName, value })
      .then(() => this.props.onChange());
  }

  toggleModalPicture(bool, typePicture = 'horizontal') {
    const websiteContent = this.props.objectData.website;
    const fieldname = `${typePicture}_image`;
    let editedPicture = null;
    if (bool) {
      editedPicture = websiteContent[fieldname]
        ? websiteContent[fieldname]
        : {};
    }
    this.props.api.propertyContent.setData({ showModalPicture: bool, editedPicture, typePicture });
  }
  handleChangePicture(picture) {
    this.props.api.propertyContent.setData({ editedPicture: picture });
  }
  handleUploadPicture() {
    const editedPicture = this.props.editedPicture;
    if (!editedPicture.original && !editedPicture._new) return null;
    const typePicture = this.props.typePicture;
    this.props.api.propertyContent.savePicture({ typePicture, contentId: this.props.objectData.id, picture: editedPicture });
  }
  toggleModalDeletePicture(bool, typePicture = 'horizontal') {
    this.props.api.propertyContent.setData({ showModalDeletePicture: bool, typePicture });
  }
  handleDeletePicture() {
    const typePicture = this.props.typePicture;
    const fieldname = `${typePicture}_image`;
    const pictureId = this.props.objectData.website[fieldname].id;
    this.props.api.propertyContent.deletePicture({ typePicture, contentId: this.props.objectData.id, pictureId });
  }

  toggleModalGallery(bool) {
    const showModalGallery = bool;
    this.props.api.propertyContent.setData({ showModalGallery, selectedPictures: [] });
  }
  handleChoosePictures(field) {
    const picturesIds = field.value;
    this.props.api.propertyContent.setData({ selectedPictures: picturesIds });
  }
  geGalleryPictures(gallery) {
    const propertyPictures = this.props.api.getState('property').objectData.pictures || [];
    const picturesIds = propertyPictures.map(p => p.id);
    return (gallery || []).filter(pic => picturesIds.includes(pic.id));
  }
  handleAddGalleryPictures() {
    const picturesIds = this.props.selectedPictures;
    const propertyPictures = this.props.api.getState('property').objectData.pictures || [];
    const addedPictures = propertyPictures
      .filter(p => picturesIds.indexOf(p.id) !== -1)
      .map(p => ({ id: p.id, filename: p.original.value.name }));
    const websiteContent = { ...this.props.objectData.website };
    websiteContent.gallery = this.geGalleryPictures(websiteContent.gallery).concat(addedPictures);
    this.handleChange('website', websiteContent);
    this.toggleModalGallery(false);
  }
  handleMovePicture(direction, index) {
    const websiteContent = { ...this.props.objectData.website };
    const galleryPictures = this.geGalleryPictures(websiteContent.gallery);
    const picture = galleryPictures[index];
    let doMove = false;
    let newIndex;
    if (direction === 'up') {
      if (index !== 0) {
        doMove = true;
        newIndex = index - 1;
      }
    } else {
      if (index !== galleryPictures.length - 1) {
        doMove = true;
        newIndex = index + 1;
      }
    }
    if (doMove) {
      galleryPictures.splice(index, 1);
      galleryPictures.splice(newIndex, 0, picture);
      websiteContent.gallery = galleryPictures;
      this.handleChange('website', websiteContent);
    }
  }
  toggleModalRemoveGalleryPicture(indexRemovePicture = -1) {
    const showModalRemoveGalleryPicture = indexRemovePicture !== -1;
    this.props.api.propertyContent.setData({ showModalRemoveGalleryPicture, indexRemovePicture });
  }
  handleRemoveGalleryPicture() {
    const websiteContent = { ...this.props.objectData.website };
    const galleryPictures = this.geGalleryPictures(websiteContent.gallery);
    galleryPictures.splice(this.props.indexRemovePicture, 1);
    websiteContent.gallery = galleryPictures;
    this.handleChange('website', websiteContent);
    this.toggleModalRemoveGalleryPicture(-1);
  }
}

export default api.connect(Form, 'propertyContent');



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/containers/Form.jsx